import { mdiAccount, mdiAccountMultiple } from '@mdi/js'
import Icon from '@mdi/react'
import { useAtom } from 'jotai'

import { Box } from '@/components/ui/box'
import { Flex } from '@/components/ui/flex'
import { Text } from '@/components/ui/typography'
import { compliancesAtom } from '@/store/tasksApprovals'
import { getDataForMyLearning, getDaysText, getDueOverDueText } from '@/store/tasksApprovals/utils'
import { TCompliancesData, TCompliancesDataAsObject, TMyLearning } from '@/types/tasksApprovals'

import InfoIcon from '../../../InfoIcon'

const RightSide = ({
    iconColor,
    textColor,
    directsCompliances,
    myCompliances,
    totals,
    isSelected,
}: {
    iconColor: string
    textColor: string
    myCompliances: TCompliancesData
    directsCompliances: TCompliancesData
    totals: TCompliancesDataAsObject
    isSelected: boolean
}) => {
    const [compliances] = useAtom(compliancesAtom)

    if (directsCompliances === 0 && typeof myCompliances === 'object') {
        const getOverdueOrDueInData = (type: TMyLearning) => {
            const system = type === 'MANDATORY' ? 'MY_LEARNING' : 'MY_LEARNING_RO'
            const data = getDataForMyLearning(
                compliances.filter((item) => item.system_id === system).filter((item) => item.metadata?.type === type),
            )[0]

            if (data.over_due) {
                data.bodyText = `${data.countHigherItemOverDue} ${getDueOverDueText(data.over_due, 'overdue', 'short')} ${getDaysText(data.over_due, 'overdue')}`
                data.icon = <InfoIcon days={data.over_due} isSelected={isSelected} status="overdue" />
            } else if (data.due_in) {
                data.bodyText = `${data.countHigherItemDue} ${getDueOverDueText(data.due_in, 'duein', 'short')} ${getDaysText(data.due_in, 'duein')}`
                data.icon = <InfoIcon days={data.due_in} isSelected={isSelected} status="duein" />
            }
            return data
        }

        return (
            <Flex flexDir="column" gap="4px" justifyContent="space-between" alignItems="end" mr="8px">
                {(['MANDATORY', 'REQUIRED', 'OPTIONAL'] as TMyLearning[]).map((type: TMyLearning) => {
                    if (myCompliances[type] > 0) {
                        const { icon, bodyText } = getOverdueOrDueInData(type)

                        return (
                            <Flex alignItems="center" gap="4px" key={type}>
                                <Box>{icon}</Box>
                                <Text color={textColor} fontSize="12px">
                                    {bodyText}
                                </Text>
                            </Flex>
                        )
                    }
                })}
            </Flex>
        )
    } else if (typeof myCompliances === 'object' && typeof directsCompliances === 'object')
        return (
            <Flex flexDir="column" gap="6px" justifyContent="space-between" mr="8px">
                {(['MANDATORY', 'REQUIRED', 'OPTIONAL'] as TMyLearning[]).map((type) => {
                    if (totals[type] > 0) {
                        return (
                            <Flex gap="8px" justifyContent="end" key={type}>
                                {myCompliances[type] > 0 && (
                                    <Flex alignItems="center">
                                        <Icon path={mdiAccount} size="16px" color={iconColor} />
                                        <Text fontSize="12px" textAlign="right" color={textColor}>
                                            {myCompliances[type]}
                                        </Text>
                                    </Flex>
                                )}
                                {directsCompliances[type] > 0 && (
                                    <Flex alignItems="center">
                                        <Icon path={mdiAccountMultiple} size="16px" color={iconColor} />
                                        <Text textAlign="right" fontSize="12px" color={textColor}>
                                            {directsCompliances[type]}
                                        </Text>
                                    </Flex>
                                )}
                            </Flex>
                        )
                    }
                })}
            </Flex>
        )
}

export default RightSide
